<template>
  <section v-on:click="sectionClicked"
    :class="{filterOpen: filterOpen}">
    <Header class="scrolled uncorupted" menu="merchandise" ref="header"
      :merchandise="true"/>
    <McHeader class="scrolled filter address" :class="{filterOpen: filterOpen}"
      title="Transaksi" ref="mcHeader"/>
    <UserMenu v-on:filterToggle="filterOpen = !filterOpen" :menuActive="menuActive"/>
    <div v-if="notLogedIn"></div>
    <div class="itemCnt" v-else>
      <div class="itemOk">
        <div class="searchCnt">
          <h4>Daftar transaksi</h4>
          <form v-on:submit.prevent="search">
            <div class="searchIcon"></div>
            <input type="text" placeholder="Cari nomor transaksi..."
              v-model="q" v-on:input="search">
          </form>
        </div>
        <div class="loading" v-if="loading">
          <div class="progress">
            <div class="indeterminate"></div>
          </div>
        </div>
        <div v-else-if="trx.length < 1" class="noTrx">
          <div>
            <img src="../assets/trx-pending.png">
            <h4>Belum ada transaksi</h4>
            <p>Semua transaksi kamu dapat dilihat disini</p>
            <a href="/uncorupted/browse" class="btn primary">Cari Produk</a>
          </div>
        </div>
        <div class="addresses" v-else>
          <div class="addressItem" v-for="(item, i) in trx" :key="i"
            v-on:click="viewDetail(item)">
            <div class="price" v-if="item.grandTotal">
              <div><span>Total belanja</span>Rp {{item.grandTotal.toLocaleString('id')}}</div>
            </div>
            <h4>{{item.orderNo}} <span class="bull">&bull;</span>
              <span class="trxDate">{{item.orderDate | moment('dd MMM YYYY HH:mm')}}</span>
              <span class="status" :class="item.status">{{item.status}}</span>
            </h4>
            <div class="product" v-if="item.products && item.products.length > 0">
              <div class="productImg noImg"></div>
              <h4>{{item.products[0].product.name}}</h4>
              <p v-if="item.products.length > 1">+{{item.products.length - 1}} lainya</p>
            </div>
            <div class="addressAction" v-on:click.stop="doNothing">
              <button class="btn primary" v-on:click.stop="completeOrder(i, item)"
                v-if="item.status === 'On Delivery' || item.status === 'Delivered'">
                Selesaikan <span>pesanan</span></button>
              <a :href="`https://wa.me/628111845189?text=${item.contactText}`" target="_blank"
                class="btn secondary">Hubungi <span>layanan pelanggan</span></a>
              <button class="btn secondary negative" v-on:click.stop="cancelOrder(i, item)"
                v-if="item.status === 'Pending' || item.status === 'Payment Verified'">
                Batalkan <span>pesanan</span></button>
            </div>
          </div>
        </div>
        <div class="copyright">&copy; Copyright {{d.getFullYear()}}
        Sahabat ICW. All right reserved.</div>
      </div>
    </div>
    <CancelOrder ref="cancelOrder"/>
    <Confirmation ref="confirmDialog"/>
    <TrxDetail ref="trxDetail"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import McHeader from '@/components/McHeader.vue';
import UserMenu from '@/components/UserMenu.vue';
import CancelOrder from '@/components/CancelOrder.vue';
import Confirmation from '@/components/Confirmation.vue';
import TrxDetail from '@/components/TrxDetail.vue';

export default {
  name: 'home',
  components: {
    Header,
    McHeader,
    UserMenu,
    CancelOrder,
    Confirmation,
    TrxDetail,
  },
  data() {
    return {
      notLogedIn: true,
      filterOpen: true,
      loading: false,
      trx: [],
      d: new Date(),
      menuActive: 'trx',

      /**
       * Search and sorting
       *
       */
      q: '',
      searchTimer: null,
    };
  },
  methods: {
    doNothing() {},
    viewDetail(item) {
      this.$refs.trxDetail.open(item);
    },
    completeOrder(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Selesaikan Pesanan',
        desc: `Apakah kamu yakin ingin menyelesaikan pesanan ini? Pastikan
          barang yang kamu terima sesuai dengan yang kamu pesan.`,
        action: 'Selesaikan Pesanan',
      }, (b) => {
        if (!b) return;
        this.trx[i].status = 'Completed';
        this.$http.post(this.$config.uri(`user/purchase/${item.id}/status`), {
          status: 'Completed',
        }).then((r) => {});
      });
    },
    cancelOrder(i, item) {
      this.$refs.cancelOrder.open(item, (b) => {
        if (!b) return;
        this.trx[i].status = 'Canceled by Buyer';
      });
    },
    search() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getTrx();
      }, 500);
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
      if (this.$refs.mcHeader) this.$refs.mcHeader.headerClicked();
    },
    loadMore() {
      const { parent } = this.$route.params;
      if (parent === 'amagram' || parent === 'amagram-internal'
        || parent === 'leaders-newsletter' || parent === 'bulletin') {
        this.loadingMore = false;
        return;
      }
      if (!this.category) {
        this.loadingMore = false;
        return;
      }
      const year = (this.$route.params.year && this.$route.params.year !== 'all')
        ? `&year=${this.$route.params.year}` : '';
      this.page += 1;
      this.$http.post(this.$config.uri(`content/all?parentId=${this.category.id}${year}&limit=12&page=${this.page}`), {
        filter: this.allFilter,
      }).then((rr) => {
        this.loadingMore = false;
        if (rr.data.status !== 200) {
          this.canLoadMore = false;
          return;
        }
        this.results.push(...rr.data.data);
      });
    },
    getTrx() {
      const { status } = this.$route.query;
      switch (status) {
        case 'ongoing': this.menuActive = 'trxOngoing'; break;
        case 'success': this.menuActive = 'trxSuccess'; break;
        case 'failed': this.menuActive = 'trxCanceled'; break;
        default: break;
      }
      this.$http.get(this.$config.uri(`user/purchase?status=${status}&q=${this.q}`)).then((r) => {
        this.trx = (r.data.status === 200) ? r.data.data : [];
      });
    },
    windowScrolled() {
      // const reachBot = document.documentElement.scrollTop + window.innerHeight
      //   >= document.documentElement.offsetHeight -
      // (document.getElementById('footer').clientHeight
      //   + 400);
      // if (reachBot && !this.loadingMore && this.canLoadMore) {
      //   this.loadingMore = true;
      //   this.loadMore();
      // }
    },
  },
  created() {
    document.getElementsByTagName('BODY')[0].classList.add('hideFooter');
  },
  destroyed() {
    document.getElementsByTagName('BODY')[0].classList.remove('hideFooter');
  },
  beforeDestroy() {},
  mounted() {
    document.title = this.$config.appName;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.q = this.$route.query.q || '';
    this.getTrx();
    if (this.$session.get('shb_icw_logged_in')) {
      this.notLogedIn = false;
    } else {
      this.$refs.mcHeader.openAccount();
    }
  },
};
</script>

<style scoped lang="scss">
.itemCnt{
  margin-left: 50px;
  padding-top: 134px;
  @media (max-width: 760px) {
    padding-top: 104px;
  }
  @media (max-width: 680px) {
    // margin-left: 0;
    padding-top: 116px;
    padding-bottom: 60px;
  }
  .itemOk{
    padding-top: 0;
    margin: 0 auto;
    max-width: 960px;
  }
}
.filterOpen{
  .itemCnt{
    margin-left: 300px;
    @media (max-width: 1140px) {
      margin-left: 50px;
    }
    @media (max-width: 680px) {
      // margin-left: 0;
    }
  }
}

.copyright{
  text-align: center;
  padding: 40px 20px 20px;
  font-size: 14px;
  color: #767676;
  @media (max-width: 680px) {
    padding: 20px 20px 30px;
  }
}

.searchCnt{
  padding: 20px;
  display: flex;
  align-items: center;
  @media (max-width: 680px) {
    padding: 0 16px 10px;
  }
  form{
    position: relative;
    width: calc(100% - 380px);
    @media (max-width: 1260px) {
      width: calc(100% - 260px);
    }
    @media (max-width: 760px) {
      width: calc(100% - 140px);
    }
    @media (max-width: 680px) {
      width: 100%;
    }
    .searchIcon{
      position: absolute;
      left: 10px; top: 0; bottom: 2px;
      z-index: 3; width: 30px;
      background-image: url(../assets/search.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    input{
      padding: 10px 14px 11px;
      width: 100%;
      border-radius: 5px;
      box-sizing: border-box;
      border: #ccc 1px solid;
      padding-left: 46px;
      font-weight: 400;
      font-size: 14px;
      background-color: #fff;
      &:hover{
        border-color: #222;
      }
    }
  }
  h4{
    margin: 0;
    margin-right: auto;
    font-size: 22px;
    @media (max-width: 680px) {
      display: none;
    }
  }
}

.loadingMore{
  text-align: center;
  padding: 20px 0 26px;
  color: #767676;
  font-size: 15px;
  .loadingImg{
    height: 36px;
    background-image: url(../assets/loading.svg);
    background-position: center;
    background-size: 36px auto;
    background-repeat: no-repeat;
    margin-bottom: 10px;
  }
}

@keyframes indeterminate {
  0% { left: -35%; right: 100%; }
  60% { left: 100%; right: -90%; }
  100% { left: 100%; right: -90%; }
}
@keyframes indeterminate-short {
  0% { left: -200%; right: 100%; }
  60% { left: 107%; right: -8%; }
  100% { left: 107%; right: -8%; }
}
.loading{
  margin: 20px 20px;
  .progress{
    height: 4px;
    background-color: #bbcee8;
    position: relative;
    overflow: hidden;
    .indeterminate {
      background-color: #5184c6;
      &:before{
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0; left: 0; bottom: 0;
        will-change: left, right;
        animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      }
      &:after {
        content: '';
        position: absolute;
        background-color: inherit;
        top: 0;
        left: 0;
        bottom: 0;
        will-change: left, right;
        animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
        animation-delay: 1.15s;
      }
    }
  }
}
.totalItem{
  margin: -10px 20px 20px;
  color: #767676;
}
.sectionTitle{
  font-size: 18px;
  color: #767676;
  margin: 6px 40px;
  text-align: left;
  @media (max-width: 680px) {
    margin: 6px 36px;
  }
}

.noTrx{
  min-height: calc(100vh - 320px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  img{
    width: 80px;
    margin: 0 0 20px;
  }
  h4{
    font-size: 22px;
    font-weight: 500;
    margin: 0 0 10px;
  }
  p{
    margin: 0 0 30px;
    max-width: 540px;
    font-size: 15px;
    color: #767676;
  }
}

.addresses{
  padding: 0 20px;
  @media (max-width: 680px) {
    padding: 0 16px;
  }
  .addressItem{
    border-radius: 5px;
    border: #eee 1px solid;
    // box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
    padding: 16px 20px 0;
    padding-right: 200px;
    margin-bottom: 20px;
    position: relative;
    cursor: pointer;
    @media (max-width: 940px) {
      padding-right: 20px;
    }
    @media (max-width: 680px) {
      margin-bottom: 10px;
    }
    .price{
      position: absolute;
      right: 20px; top: 0; bottom: 0;
      display: flex;
      align-items: center;
      border-left: #eee 1px solid;
      width: 160px;
      text-align: left;
      padding-left: 20px;
      box-sizing: border-box;
      font-weight: 800;
      font-size: 18px;
      @media (max-width: 940px) {
        position: static;
        border: none;
        border-bottom: #eee 1px solid;
        width: auto;
        font-size: 16px;
        display: block;
        padding: 0 20px 8px;
        margin: -4px -20px 14px;
      }
      div{
        @media (max-width: 940px) {
          display: flex;
        }
      }
      span{
        display: block;
        font-weight: 500;
        color: #767676;
        font-size: 14px;
        margin-bottom: 2px;
        @media (max-width: 940px) {
          margin: 0;
          font-size: inherit;
          margin-right: auto;
        }
      }
    }
    h4{
      margin: 0 0 10px;
      font-weight: 400;
      font-size: 14px;
      @media (max-width: 680px) {
        margin: 0 0 16px;
      }
      span{
        @media (max-width: 680px) {
          display: block;
          margin: 4px 0 !important;
        }
      }
      span.bull{
        color: #767676;
        margin: 0 4px;
        display: none;
      }
      span.trxDate{
        margin-left: 10px;
      }
      span.status{
        margin-right: 10px;
        color: #444;
        position: relative;
        padding-left: 12px;
        margin-left: 16px;
        font-weight: 600;
        &:before{
          content: "";
          position: absolute;
          width: 12px; height: 12px;
          width: 5px; height: 16px;
          // border-radius: 50%;
          background-color: #ccc;
          border-radius: 50px;
          top: 50%; margin-top: -8px;
          left: 0;
        }
        &.Pending{
          color: #eb9a00;
          &:before{
            background-color: orange;
          }
        }
        &.Payment.Failed,
        &.Payment.Expired,
        &.Canceled{
          color: red;
          &:before{
            background-color: red;
          }
        }
        &.Processing,
        &.On.Delivery,
        &.Delivered{
          color: purple;
          &:before{
            background-color: purple;
          }
        }
        &.Payment.Verified{
          color: blue;
          &:before{
            background-color: blue;
          }
        }
        &.Completed{
          color: green;
          &:before{
            background-color: green;
          }
        }
      }
    }
    .product{
      position: relative;
      padding-left: 58px;
      min-height: 46px;
      .productImg{
        width: 46px; height: 46px;
        background-color: #eee;
        border-radius: 3px;
        position: absolute;
        left: 0; top: 0;
        &.noImg{
          background-image: url(../assets/image-black.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #ddd;
          opacity: .3;
        }
      }
      h4{
        font-size: 15px;
        font-weight: 600;
        margin: 0 0 2px;
      }
      p{
        margin: 0;
        color: #767676;
        font-size: 13px;
      }
    }
    .addressAction{
      display: flex;
      padding: 6px 20px;
      border-top: #eee 1px solid;
      margin: 16px -20px 0;
      cursor: default;
      .btn{
        padding: 0;
        margin-right: 30px;
        font-size: 15px;
        box-shadow: none;
        height: 38px;
        line-height: 38px;
        &.primary{
          padding: 0 16px;
          margin-right: 30px;
        }
        span{
          @media (max-width: 680px) {
            display: none;
          }
        }
      }
    }
  }
}
</style>
